import { useTranslation } from 'react-i18next';

import { ContentDetailsBox } from '../ContentDetailsBox/ContentDetailsBox';
import { DetailedBenefit } from '../../utils';
import { PlanDetailsSectionResponseDto } from './types';
import { mapPlanContentDetails, mapCurrentBenefitDetails } from './utils/utils';
import { PlanDetailsTitleStyled } from './PlanDetailsStyled';

export interface PlanDetailsProps {
  planData?: PlanDetailsSectionResponseDto;
  detailedBenefit?: DetailedBenefit;
}

export const PlanDetails = ({
  planData,
  detailedBenefit,
}: PlanDetailsProps) => {
  const planContentDetails =
    planData && mapPlanContentDetails(planData.data.org_plan_content_details);

  const currentBenefitDetails =
    detailedBenefit && mapCurrentBenefitDetails(detailedBenefit);

  const { t } = useTranslation('pages.benefits');
  const detailsExist =
    (currentBenefitDetails && currentBenefitDetails.length > 0) ||
    (planContentDetails && planContentDetails.length > 0);

  return (
    <>
      {detailsExist && (
        <PlanDetailsTitleStyled
          data-testid="plan-details"
          className="headline-3"
        >
          {t('planDetails')}
        </PlanDetailsTitleStyled>
      )}
      {currentBenefitDetails?.map((item, index) => (
        <ContentDetailsBox
          key={index}
          label={t(item.label)}
          text={
            item.isNumber
              ? t('common:currency', {
                  value: item.value,
                  minimumFractionDigits: 2,
                })
              : item.value
          }
        />
      ))}
      {planContentDetails?.map((item) => (
        <ContentDetailsBox
          key={item.id}
          label={item.label}
          inNetworkValue={item.inNetwork}
          outOfNetworkValue={item.outOfNetwork}
          preferredNetwork={item.preferredNetwork}
        />
      ))}
    </>
  );
};
